export default "__VITE_ASSET__N6BG87$R__"